import { useRouting, useRoutingConfig } from '@rad/hooks/useRouting';
import { browseProperties, resolveBackLink } from '../common/routes/back-link';
import useAuth from './useAuth';
// A page's "Back to …" button: a step back to where the visitor came from when that page has a name,
// else the onward link the page supplies. `own` names a page this one knows better than by its route.
// Returns a resolver because a page may only know its onward link once its data has loaded.
const useBackLink = () => {
    const strategy = useRoutingConfig();
    const [location] = useRouting();
    const origin = strategy.origin();
    return (onward, own = null) => resolveBackLink(strategy.parse, location, origin, onward, own);
};
// The button on a page about a place, whose onward link is to browse more homes.
export const usePropertyBack = () => {
    const [auth] = useAuth();
    const resolveBack = useBackLink();
    return (own = null) => resolveBack(browseProperties(auth.isAuthenticated), own);
};
export default useBackLink;
